<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span>Products</span>
                    <a>List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center margin497">
                    <!--Delete Product-->
                    <!-- <button type="button" v-if="userPermissions.products.permitted_actions.delete"
                        :style="selectedIds.length ? '' : 'background-color: #ababab; border-color: #ababab'"
                        :class="{'pointer-event':selectedIds.length == 0}" class="btn btn-smm btn-danger ml-3"
                        style="border-radius: 6px !important;" @click="productDelete">
                        <i class="icon icon-minus fs-12 text-white"></i>
                        Delete
                    </button> -->
                    <!--Add Product-->
                    <!-- <button type="button" v-if="userPermissions.products.permitted_actions.create" class="btn btn-smm text-white btn-success ml-3"
                        style="border-radius: 6px !important; background-color: #128807 !important;" @click="openProductAddModal()">
                        <i class="icon icon-plus fs-12 text-white" style="color: #fff !important; background-color: #128807 !important;"></i>
                        Add Product
                    </button> -->
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div> -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li class="tab-current">
                                <a href="javascript:;" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>List View</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" v-model="search_key" @input="searchProducts" class="w-100 placeholder-text" type="text"
                            placeholder="Search by Product Name"
                            style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                </div>
            </div>
            <div
                style="background: #fff; border-top-right-radius: 5px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px">
                <div class="py-5">
                    <div class="infoHeader">
                        <div class="d-flex justify-content-between align-items-center" style="background-color: #00448b; ">
                            <h6 class="subHeaderTitle ml-13 text-white text-uppercase">Product List</h6>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center h-100 pt-8" v-if="ajaxCallInProgress">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                    </div>
                    <div v-else :class="{'overflow-products':products.length}" class="px-5 ml-8">
                        <div class="row" id="contact-list-grid">
                            <div class="w-100"
                                v-if="!ajaxCallInProgress && products.length == 0" style="height: 400px;">
                                <div class="d-flex justify-content-center align-items-center w-100 pt-20" >
                                    <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                </div>
                                <div class="d-flex justify-content-center align-items-center w-100 pl-10" >
                                    <div class="text-center"> No Product added!</div>
                                </div>
                            </div>
                            <div v-else-if="!ajaxCallInProgress && products" class="column-wdth col-12 col-lg-3 col-md-4 col-sm-12" v-for="(product,index) in products" :key="index">
                                <div class=" bg-white py-3 mt-5" style="box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);border-radius:5px;">
                                    <div class="px-2 product-padding">
                                        <div class="d-flex align-items-center product-img">
                                            <img @click="openProductViewModal(product)" :src="product.logo ? product.logo : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/SCM.svg'" style="height: 6em; width: 6em; border-radius: 10px;padding:20px;border:1px solid #00448b" alt="">
                                            <!--Product List View-->
                                            <div class="ml-2 d-flex justify-content-between flex-column content-margin w-100">
                                                <!-- <div class="d-flex ml-auto" style="position: absolute;right: 22px;top: 35px;">
                                                    <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                        <input type="checkbox" class="custom-control-input" @click="singleSelect(product)" v-model="selectedIds" :value="product._id" />
                                                        <span class="custom-control-indicator" style="font-size: 20px;top: -20px !important;left: -7px !important;"></span>
                                                        <span class="form-check-description fw-600"></span>
                                                    </label>
                                                </div> -->
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <h3 class="fs-15 fw-500 pointer mb-0 product-heading text-truncate" style="max-width:150px !important;" :title="product.name" @click="openProductViewModal(product)">
                                                        {{product.name}}
                                                    </h3>
                                                    <sup v-if="product.is_star" class="text-right" style="top: 0em !important;width: 20px;">
                                                        <el-tooltip class="item" effect="dark" content="Starred" placement="top">
                                                            <i class="icon icon-star" style="color: rgb(255, 154, 6);"></i>
                                                        </el-tooltip>
                                                    </sup>
                                                </div>
                                                <span class="fs-12 mt-1 pointer text-truncate" @click="openProductViewModal(product)" style="max-width: 260px;" :title="product.description">{{product.sub_category}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!ajaxCallInProgress && products.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4"
                        style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                        <!--Pagination-->
                        <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                        :options="pageLimit" :close-on-select="true" v-model.number="limit" :max-height="210"
                        open-direction="top" :show-labels="false" placeholder="" :allow-empty="false" :searchable="false"
                        style="width: 4.2em !important;padding-right: 10px!important;">
                        </multiselect>
                        <span class="page-info pr-2 pl-6 fw-500 text-dark font-size-small">Per page</span>
                        <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                            <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                <i class="icon-chevron-double-left"></i>
                            </el-tooltip>
                        </button>
                        <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                            <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                <i class="icon icon-chevron-left"></i>
                            </el-tooltip>
                        </button>
                        <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} -
                            {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                        <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                            <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                <i class="icon icon-chevron-right"></i>
                            </el-tooltip>
                        </button>
                        <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                            <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                <i class="icon-chevron-double-right"></i>
                            </el-tooltip>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <add-product @createProducts="createProducts" modal_name="Add_Product" @hide-add-product-modal="hideAddProduct"
            v-if="addproduct"></add-product>
        <product-view @updatedProducts="updateProducts" :selected_product="selected_product" modal_name="View_Product"
            @hide-view-product-modal="hideViewProduct" v-if="viewproduct"></product-view>
        <delete-product modal_name="Delete_product" :product_ids="selectedIds" @deleteProduct="deleteProduct"
            @hide-delete-product-modal="hideDeleteProduct" v-if="deleteproduct"></delete-product>
        <success-message v-if="success_product" :message="message" modal_name="success-message"
            @hideSuccess="hideSuccess"></success-message>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    const SuccessMessage = () => import("../SuccessMessage");
    import DeleteProduct from "./DeleteProduct"
    import {
        EventBus
    } from "../eventBus/nav-bar-event.js";
    import ProductView from "./ProductView"
    import products from '../mixins/products';
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import AddProduct from "./AddProduct"
    import { debounce } from 'lodash';

    export default ({
        data() {
            return {
                ajaxCallInProgress: false,
                start: 0,
                end: 0,
                total: 0,
                count: 0,
                limit: 12,
                skip: 0,
                temp_total: 0,
                skip_temp: 0,
                productinformation: false,
                deleteproduct: false,
                viewproduct: false,
                addproduct: false,
                search_key: "",
                products: [],
                selectedIds: [],
                selected_product: null,
                success_product: false,
                message: '',
                pageLimit: [],
            }
        },
        components: {
            SuccessMessage,
            ProductView,
            DeleteProduct,
            products,
            SweetModal,
            AddProduct,
            HalfCircleSpinner
        },
        mixins: [products],
        methods: {
            clearSearch(){
                this.search_key = "";
                this.$refs.searchInput.focus();
                this.loadProducts();
            },
           //Hiding the success Modal of Updation and relaoding the load products to show the updated data
            hideSuccess() {
                this.success_product = false
                setTimeout(() => {
                    this.loadProducts()
                }, 500);
            },
            //Select single Product to delete
            /**@params = value */
            singleSelect(value) {
                if (this.selectedIds.find(x => x === value._id)) {
                    this.selectedIds = this.selectedIds.filter(function (x) {
                        if (x !== value._id) {
                            return x;
                        }
                    });
                } else {
                    this.selectedIds.push(value._id)
                }
            },
            //Show Product Delete Confirmation Modal
            openDeleteProductModal() {
                this.deleteproduct = true
                setTimeout(() => {
                    this.$modal.show("Delete_product")
                }, 500)
            },
            //Hide Product Delete Confirmation Modal
            hideDeleteProduct() {
                this.deleteproduct = false

            },
            //API Call For Delete Prodcut
            deleteProduct() {
                this.deleteproduct = false
                this.message = "Products Deleted Successfully"
                this.success_product = true;
                this.selectedIds = []
                setTimeout(() => {
                    this.$modal.show('success-message');
                    this.loadProducts();
                }, 500);
            },
             //API Call To Update Prodcut
            updateProducts() {
                this.message = "Product Updated Successfully"
                this.success_product = true;
                setTimeout(() => {
                    this.$modal.show('success-message');
                    this.loadProducts();
                }, 500);
            },
            createProducts() {
                this.loadProducts()
            },
            //Hide Add Product Modal
            hideAddProduct() {
                this.addproduct = false
            },
            //Show Edit/View Product Modal
            openProductViewModal(product) {
                // let id = null
                if(typeof product._id === 'object'){
                    this.selected_product = product._id
                }
                else{
                    this.selected_product = product._id
                }
                // this.selected_product = product
                    this.viewproduct = true
                    setTimeout(() => {
                        this.$modal.show("View_Product")
                    }, 500)
                // if(this.userPermissions.products.permitted_actions.view){
                //     product['created_time_format'] = parseFloat(product.created_time)
                //     var date = new Date(product.created_time_format);
                //     var hours = date.getHours();
                //     var minutes = date.getMinutes();
                //     // Check whether AM or PM
                //     var newformat = hours >= 12 ? 'PM' : 'AM';
                //     // Find current hour in AM-PM Format
                //     hours = hours % 12;
                //     // To display "0" as "12"
                //     hours = hours ? hours : 12;
                //     minutes = minutes < 10 ? '0' + minutes : minutes;
                //     product.created_time_format = hours + ':' + minutes + ' ' + newformat;
                //     this.selected_product = product
                //     this.viewproduct = true
                //     setTimeout(() => {
                //         this.$modal.show("View_Product")
                //     }, 500)
                // }
                // else{
                //     this.$toasted.global.error("Permission Denied")
                // }
            },
            //Show Add Product Modal
            openProductAddModal() {
                this.addproduct = true
                setTimeout(() => {
                    this.$modal.show("Add_Product")
                }, 500)
            },
            //Hide Edit/View Product Modal
            hideViewProduct() {
                this.viewproduct = false
            },
            //API Call For Search Products
            async searchProductsDebouncer() {
                this.ajaxCallInProgress = true;
                this.selectedIds = []
                let params = {
                    // search_key: this.search_key,
                    // sort_value: 1,
                    // sort_key: "is_star",
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                    sort_key: "name",
                    sort_value: 1,
                    category_ids:[],
                    sub_category_ids:[],
                    product_type_ids:[],
                    product_ids:[],
                    brand_ids:[],
                    outlet_ids:[],
                    status:[],
                    visibility:"Manufacturing"
                }
                let response = await this.ProductsList(params);
                this.products = response.response.result
                // this.products.forEach(x => {
                //     if (x.logo == 'string' || x.logo == 'string4') {
                //         x.logo = ''
                //     }
                // })
                this.total = response.response.product_count
                this.ajaxCallInProgress = false;
            },
            //API Call To load List Of Products
            async loadProducts() {
                //this.selectedIds = []
                //this.ajaxCallInProgress = true
                let params = {
                    // skip: this.skip,
                    // limit: this.limit,
                    // search_key: this.search_key,
                    // sort_value: 1,
                    // sort_key: "is_star",
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                    sort_key: "name",
                    sort_value: 1,
                    category_ids:[],
                    sub_category_ids:[],
                    product_type_ids:[],
                    product_ids:[],
                    brand_ids:[],
                    outlet_ids:[],
                    status:[],
                    visibility:"Manufacturing"
                    // brand_ids: [],
                    // category_ids: [],
                    // ingredients: false,
                    // limit: this.limit,
                    // max_amount: '',
                    // max_quantity: '',
                    // min_amount: '',
                    // min_quantity: '',
                    // outlet_id: "",
                    // outlet_ids: [],
                    // product_ids: [],
                    // product_type_ids: [],
                    // searchdata: this.search_key.trim(),
                    // skip: this.skip,
                    // sort_key: "name",
                    // sort_value: 1,
                    // status: [],
                    // sub_category_ids: [],
                    // visibility: "Manufacturing"
                }
                let response = await this.ProductsList(params);
                this.products = response.response.result
                // this.products.forEach(x => {
                //     if (x.logo == 'string') {
                //         x.logo = ''
                //     }
                // })
                this.total = response.response.product_count
                this.ajaxCallInProgress = false
            },
            //Pagination Start//
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.skip_temp = 0
                this.products = []
                this.ajaxCallInProgress = true
                this.loadProducts()
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.ajaxCallInProgress = true
                this.loadProducts();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.ajaxCallInProgress = true
                this.loadProducts();
            },
            previousPage() {
                this.skip_temp = 0
                this.temp_total = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.ajaxCallInProgress = true
                this.loadProducts();
            },
            //Pagination End//

        },
        mounted() {
            this.ajaxCallInProgress = true
            this.loadProducts();
            //Showing the add product modal
            EventBus.$on("products", () => {
                this.addproduct = true
                setTimeout(() => {
                    this.$modal.show("Add_Product")
                }, 500);
            })
            //Setting limit of the pagination
            for (let i = 10; i <= 50; i+=10) {
                this.pageLimit.push(i);
            }
        },

        computed: {
            //Updating the count of the skip and total
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
            //using this to check the permissions for different user role
            userPermissions(){
                return this.$store.getters.userPermissions;
            }

        },
        created() {
            this.addproduct = this.$route.params.products
            setTimeout(() => {
                this.$modal.show("Add_Product")
            }, 500);
            //Debounce method is using to call the search API only one time.
            this.searchProducts = debounce(this.searchProductsDebouncer, 500)
        },
        watch: {
            limit: function(){
                this.loadProducts();
            }
        },
    })
</script>

<style scoped>
    .overflow-products {
        overflow-x: hidden;
        height: 500px;
    }

    .contentCenter {
        margin: 0 auto;
    }

    .product-img {
        justify-content: start;
    }
    .card {
        position: relative;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        -webkit-background-clip: border-box;
        background-clip: border-box;
        border: 1 px solid rgba(0, 0, 0, 0.125);
        -webkit-border-radius: 0;
        border-radius: 0;
    }

    .widget-group .widget .widget-header {
        height: 5.5 rem;
    }

    .widget-group .widget .widget-content .title {
        font-size: 7.2rem;
        line-height: 7.2rem;
    }

    .no-gutters {
        margin-right: 0;
        margin-left: 0;
    }

    .tab-content>.active {
        display: block;
    }
    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 60% !important;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    @media only screen and (max-width: 497px) {
        .margin497{
            margin-bottom: 10px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/products/ProductList.vue